import React from 'react';
import { Container, Typography, Grid, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';

import SecondFooter from '../layout/SecondFooter';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <Grid className="footer" sx={{
      backgroundColor: "#0E2465",
      mt: 'auto',
      position: 'relative'
    }}>
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid container spacing={1} size={12}>
            <Grid className="content-logo" size={{ xs:12, sm:6 }} display="flex" mt={3}>
              <img alt="logo" width="224" src="/logo2.png" />
            </Grid>
            <Grid className="content-social" size={{ xs:12, sm:6 }}>
              <InstagramIcon className="btn-social" sx={{ color: '#0E2465', fontSize: {xs: 20, md: 20} }} />
              <FacebookIcon className="btn-social" sx={{ color: '#0E2465', fontSize: {xs: 20, md: 20} }} />
              <YouTubeIcon className="btn-social" sx={{ color: '#0E2465', fontSize: {xs: 20, md: 20} }} />
              <TwitterIcon className="btn-social" sx={{ color: '#0E2465', fontSize: {xs: 20, md: 20} }} />
            </Grid>
          </Grid>
          <Grid sx={{ marginBottom: {xs: 0, sm: 3}, marginTop: {xs: 2, md: 0} }} size={{ xs:12, sm:4 }}>
            <Typography color="textSecondary">Únete a nuestro círculo de servicios</Typography>
            <Typography color="textSecondary">Contrata un servicio</Typography>
            <Typography color="textSecondary">Ofrece tus servicios</Typography>
            <Typography color="textSecondary">Abre un establecimiento de negocio</Typography>
          </Grid>
          <Grid sx={{ marginBottom: {xs: 0, sm: 3}, marginTop: {xs: 2, md: 0} }} size={{ xs:12, sm:4 }} >
            <Link variant="body1" component="button" underline="none" color="textSecondary">
              Acerca de oneService
            </Link><br />
            <Link variant="body1" component="button" onClick={() => navigate("/terminos-condiciones#")} underline="none" color="textSecondary">
              Términos y condiciones
            </Link><br />
            <Link variant="body1" component="button" onClick={() => navigate("/condiciones-uso")} underline="none" color="textSecondary">
              Condiciones de uso
            </Link><br />
            <Link variant="body1" component="button" onClick={() => navigate("/cookies")} underline="none" color="textSecondary">
              Políticas de cookies
            </Link><br />
            <Link variant="body1" component="button" onClick={() => navigate("/privacidad")} underline="none" color="textSecondary">
              Politicas de privacidad
            </Link>
          </Grid>
          <Grid sx={{ marginBottom: {xs: 10, sm: 3}, marginTop: {xs: 2, md: 0} }} size={{ xs:12, sm:4 }} >
            <Typography color="textSecondary">Ayuda</Typography>
            <Typography color="textSecondary">Chat</Typography>
            <Typography color="textSecondary">Contáctanos</Typography>
            <Typography color="textSecondary">Servicios cercanos</Typography>
            <Typography color="textSecondary">Whatsapp</Typography>
          </Grid>
        </Grid>
      </Container>
      <SecondFooter />
    </Grid>
  );
}

export default Footer;